import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { Actions } from "@/store";
import ShortcutForm from "@/components/shortcut/ShortcutForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditShortcutPage',
  setup(__props) {

const store = useStore();
const route = useRoute();

onMounted(async () => {
  if (route.params.id) {
    await store.dispatch(Actions.GetShortcut, route.params.id);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ShortcutForm))
}
}

})